import tealium from '../tealium';

export function init() {
  // Hook into all RPCs to determine if the data layer has been updated
  window.addEventListener('RPC:RESULT', function (event: CustomEvent) {
    const responseData = event?.detail?.responseData;
    const requestArgs = event?.detail?.requestArgs;
    const requestId = event?.detail?.requestId;

    if (!responseData || !requestArgs) {
      return;
    }

    // Skip if we're getting the datalayer itself
    if (requestArgs && requestArgs.method === 'analytics.getDataLayer') {
      return;
    }

    // Theoretically, we could be getting back multiple responses from one json rpc request, although that isn't currently in use anywhere on the PG sites.
    for (let i = 0; i < responseData.length; i++) {
      if (
        parseInt(responseData[i].id) === requestId &&
        responseData[i].result &&
        responseData[i].result.data
      ) {
        const dataLayerUpdate = responseData[i].result.data.dataLayer;

        if (dataLayerUpdate) {
          tealium.dataLayer.update(dataLayerUpdate);
        }
      }
    }
  });
}
